// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"37":"5067da3b03e835b08e78","76":"3d261ead2eb2d2b5ced4"}[chunkId] + ".chunk.js";
};